import Options from "../data/options";
import { getDateObjectLocal } from "./Date";

const getString = (str) => {
  return str ? `_${str}` : "";
};

export const getFileName = (
  klausur,
  companies,
  schuelerList,
  schuelerId = null
) => {

  console.log({ companies , klausur, schuelerList, schuelerId});
  const schule = companies.find(
    (c) => c.id === parseInt(klausur.companyId)
  ).name;
  const schueler = schuelerId
    ? schuelerList.find((s) => s.id === schuelerId)
    : {};

  const klVals = {};
  Object.entries(klausur).forEach(
    ([k, v]) => (klVals[k] = getString(Options.getShort(k, v)))
  );
  const sVals = {};
  Object.entries(schueler).forEach(
    ([k, v]) => (sVals[k] = getString(Options.getShort(k, v)))
  );

  // console.log({ klVals, sVals });

  return `${getDateObjectLocal(klausur.createdAt).timeStamp}_${schule}${
    klVals.fach
  }${klVals.kursart}${klVals.pruefungsart}${klVals.halbjahr}${
    klVals.klausurnummer
  }${sVals.nachname ? `_${sVals.nachname}` : ""}${
    sVals.vorname ? `_${sVals.vorname}` : ""
  }`
    .replaceAll(".", "_")
    .replaceAll("___", "_")
    .replaceAll("__", "_")
    .replaceAll(" ", "_")
    .replaceAll(":", "-");
};
